import { UserRoleOwner } from "../../consts/UserRole";

import WorkspaceDto from "../workspacemodule/WorkspaceDto";

class CustomerWithWorkspacesDto {
    Id: number;
    Name: string;
    IsOwner: boolean;
    Status: number;
    StatusLabel: string;
    IsCurrent: boolean;
    EnterpriseMode: boolean;
    Workspaces: WorkspaceDto[];

    constructor(id: number, name: string, role: number, status: number, isCurrent: boolean, enterpriseMode: boolean, workspaces: WorkspaceDto[]) {
        this.Id = id;
        this.Name = name;
        this.IsOwner = role === UserRoleOwner;
        this.Status = status;
        this.StatusLabel = "";
        switch (status) {
            case 1: this.StatusLabel = "Invited"; break;
            case 2: this.StatusLabel = "Ok"; break;
            case 3: this.StatusLabel = "Revoked"; break;
        }
        this.IsCurrent = isCurrent;
        this.EnterpriseMode = enterpriseMode;
        this.Workspaces = workspaces;
    }
}

export default CustomerWithWorkspacesDto;
